export const mentionsQueryKeys = {
	all: ["mentions"] as const,
	suggest: (params: {
		query: string;
		userId: string | undefined;
		sessionId: string | undefined;
		limit: number;
	}) => [...mentionsQueryKeys.all, "suggest", params] as const,
	suggestPeople: (params: { query: string; limit?: number }) =>
		[...mentionsQueryKeys.all, "suggestPeople", params] as const,
	labels: (params: {
		ids: string[];
		updatedFrom?: string;
		userId?: string;
	}) => [...mentionsQueryKeys.all, "labels", params] as const,
	inboxRoot: () => [...mentionsQueryKeys.all, "inbox"] as const,
	inbox: (params: {
		unreadOnly: boolean;
		first?: number;
		after?: string;
	}) => [...mentionsQueryKeys.inboxRoot(), params] as const,
	unreadCount: () => [...mentionsQueryKeys.all, "unreadCount"] as const,
};
